import AxiosService from "./axiosServices";
import {
  RBAC_EXPORT_MAX_POLLS,
  RBAC_EXPORT_POLL_INTERVAL_MS,
  normalizeRbacExportStatus,
} from "../utils/userManagementUtility";

const USER_MANAGEMENT_BASE = "api/cam/srm/user-management";
const GROUP_MANAGEMENT_BASE = "api/cam/srm/group-management";
const AUDIT_TRAIL_URL = "api/cam/srm/audit-trail/";

export default class UserManagementService {
  static getUsers(params = {}) {
    return AxiosService.Get(`${USER_MANAGEMENT_BASE}/users/`, { params });
  }

  static updateUser(userId, { groupIds, isActive }) {
    const payload = {};
    if (groupIds !== undefined) payload.group_ids = groupIds;
    if (isActive !== undefined) payload.is_active = isActive;
    return AxiosService.Put(
      `${USER_MANAGEMENT_BASE}/users/${userId}/`,
      payload,
    );
  }

  static exportUsers(params = {}) {
    return AxiosService.Get(`${USER_MANAGEMENT_BASE}/users/export/`, {
      params,
    });
  }

  static getGroups(params = {}) {
    return AxiosService.Get(`${GROUP_MANAGEMENT_BASE}/groups/`, { params });
  }

  static exportGroups() {
    return AxiosService.Get(`${GROUP_MANAGEMENT_BASE}/groups/export/`);
  }

  static getExportStatus(taskId) {
    return AxiosService.Get(
      `api/cam/srm/rbac-exports/status/${encodeURIComponent(taskId)}/`,
    );
  }

  static async waitForExport(taskId) {
    for (let poll = 0; poll < RBAC_EXPORT_MAX_POLLS; poll += 1) {
      if (poll > 0) {
        await new Promise((resolve) =>
          setTimeout(resolve, RBAC_EXPORT_POLL_INTERVAL_MS),
        );
      }

      const response = await this.getExportStatus(taskId);
      const exportStatus = normalizeRbacExportStatus(response);

      if (["SUCCESS", "COMPLETED", "COMPLETE"].includes(exportStatus.status)) {
        if (!exportStatus.downloadUrl) {
          throw new Error("Export completed without a download URL.");
        }
        return exportStatus;
      }

      if (
        ["FAILURE", "FAILED", "REVOKED", "CANCELLED"].includes(
          exportStatus.status,
        )
      ) {
        throw new Error(exportStatus.message || "Export failed.");
      }
    }

    throw new Error("Export timed out. Please try again.");
  }

  static getModulesAndFeatures() {
    return AxiosService.Get(`${GROUP_MANAGEMENT_BASE}/modules-features/`);
  }

  static createGroup(payload) {
    return AxiosService.Post(
      `${GROUP_MANAGEMENT_BASE}/groups/create/`,
      payload,
    );
  }

  static updateGroup(groupId, payload) {
    return AxiosService.Put(
      `${GROUP_MANAGEMENT_BASE}/groups/${groupId}/edit/`,
      payload,
    );
  }

  static getAuditTrail(params = {}) {
    return AxiosService.Get(AUDIT_TRAIL_URL, { params });
  }
}
